export const paydaslar = [
  {
    id: 1,
    name: "Samsun Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/samsun.png",
    url: ""
  },
  {
    id: 2,
    name: "Amasya Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/amasya.png",
    url: ""
  },
  {
    id: 3,
    name: "Çankırı Karatekin Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/cankiri_karatekin.png",
    url: ""
  },
  {
    id: 4,
    name: "Hitit Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/hitit.png",
    url: ""
  },
  {
    id: 5,
    name: "Kastamonu Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/kastamonu.png",
    url: ""
  },
  {
    id: 6,
    name: "Ondokuzmayıs Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/omu1.png",
    url: ""
  },
  {
    id: 7,
    name: "Ordu Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/ordu.png",
    url: ""
  },
  {
    id: 8,
    name: "Sinop Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/sinop.png",
    url: ""
  },
  {
    id: 9,
    name: "Tokat Gazi Osman Paşa Üniversitesi",
    imageUrl: "/assets/paydasUniversiteler/tokay_gaziosmanpasa.png",
    url: ""
  }
]